import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import BasicTooltip from "src/components/BasicTooltip";
import { RHFCheckbox } from "src/components/hook-form";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import Context from "../context";

export default function CredentialsCheckbox() {
	const { customConnectProps } = useContext(Context);

	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	return (
		<Stack maxWidth={320} flexDirection={"row"} alignItems={"center"} sx={{ mt: 2 }}>
			<Typography
				fontSize={12}
				variant='body1'
				alignItems={"center"}
				color={customConnectProps?.theme?.colors.primaryText}
			>
				<RHFCheckbox
					name='storeCredentials'
					label=''
					sx={{
						p: 0.4,
						ml: -0.1,
						mr: 0.3,
						mb: 0.2,
						color: customConnectProps?.theme?.colors.secondaryText,
						"&.Mui-checked": {
							color: customConnectProps?.theme?.colors.primary
						}
					}}
				/>
				{translate("connect_panel.save_credentials")}
			</Typography>
			{!isMobile && (
				<BasicTooltip
					title={translate("connect_panel.save_credentials_tooltip")}
					link={"https://www.vumi.io/seguridad"}
				>
					<Iconify
						icon={"ci:info"}
						sx={{ ml: 1, mb: 0.1, cursor: "help" }}
						width={16}
						color={customConnectProps?.theme?.colors.primary}
					/>
				</BasicTooltip>
			)}
		</Stack>
	);
}
